import { Component, Input, OnInit } from '@angular/core';
import { DetailsQueries } from '../../queries/details.queries';
import { Select } from '@ngxs/store';
import { ConditionAndDisclosuresQuery } from '../../interfaces/condition-and-disclosures.query';
import { Observable } from 'rxjs';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { isNil } from 'lodash';
import { VehicleTireCondition, VehicleConditionDisclosuresComponent } from 'remarketing-ui-components-lib';
import { DateUtilsService } from 'remarketing-angular-library';
import { CurrencyFormatService, SaComponent } from 'smartauction-frontend-micro-library';
import { takeUntil } from 'rxjs/operators';
import { VehiclesService } from 'src/vehicles/services/vehicle-detail/vehicles.service';
import { AsyncPipe, CommonModule } from '@angular/common';

@Component({
    selector: 'lib-condition-disclosures',
    templateUrl: './condition-disclosures.component.html',
    styleUrls: ['./condition-disclosures.component.scss'],
    imports: [TranslocoDirective, VehicleConditionDisclosuresComponent, AsyncPipe, CommonModule]
})
export class ConditionDisclosuresComponent extends SaComponent implements OnInit {
  @Input() showHeading = true;
  @Select(DetailsQueries.conditionsAndDisclosures) state$: Observable<ConditionAndDisclosuresQuery>;
  vehicleConditiontransData: any;
  conditionIndicatorTranslations: any;

  formatItems = {};

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly dateUtilService: DateUtilsService,
    private readonly currencyFormatService: CurrencyFormatService,
    private readonly vehicleService: VehiclesService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  getTranslations(): void {
    this.translocoService
      .selectTranslateObject('UIComponents')
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translatedObj => {
        this.vehicleConditiontransData = translatedObj.vehicleCondition;
        this.conditionIndicatorTranslations = translatedObj.conditionIndicatorTranslations;

        //resetting the formatted items on language toggle
        this.formatItems = this.vehicleService.formatInventoryItems(this.state$);
      });
  }

  localizeDate(date) {
    return this.dateUtilService.localizeDate(date);
  }

  formatCurrency(currency, withCents) {
    return this.currencyFormatService.formatCurrency(currency, withCents);
  }

  translateTireCondition(tireCondition: VehicleTireCondition) {
    if (isNil(tireCondition.disclaimer)) {
      return tireCondition;
    }
    const translatedCondition = Object.assign({}, tireCondition);
    translatedCondition.disclaimer = this.translocoService.translate(tireCondition.disclaimer);
    return translatedCondition;
  }

  translateLegalStatements(legalStatements: string[]) {
    const translatedStatements: string[] = [];
    legalStatements.forEach(statement => {
      translatedStatements.push(this.translocoService.translate(statement));
    });
    return translatedStatements;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
